import React, { Component, ErrorInfo, ReactNode } from 'react';

import { ErrorMessage } from './AlertMessage';

interface Props {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, ErrorBoundaryState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Catch errors in any child components and re-renders with an error message
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      // Fallback UI if an error occurs
      return (
        <ErrorMessage>
          <div>
            <p className='m-0'>Something went wrong.</p>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.error && this.state.error.toString()}
              {this.state.error && this.state.error.stack?.toString()}
            </details>
          </div>
        </ErrorMessage>
      )
    }

    // Render children if there's no error
    return this.props.children;
  }
}

export default ErrorBoundary;
